import React from 'react';
import { ThumbsUp, Heart } from 'lucide-react';
interface Review {
  name: string;
  initials: string;
  avatarColor: string;
  timeAgo: string;
  text: string;
  likes: number;
  hearts: number;
  stars: number;
}
const reviews: Review[] = [{
  name: 'Rodrigo Sánchez',
  initials: 'RS',
  avatarColor: '#2d6a4f',
  timeAgo: '1 d',
  text: 'Yo también tenía mis dudas antes de comprarlo. Pero me sorprendió lo detallado que está todo. En dos días ya había terminado mi primera mesa plegable. Las medidas exactas te ahorran un montón de tiempo y material. Nada de adivinar.',
  likes: 214,
  hearts: 38,
  stars: 5
}, {
  name: 'Facundo Herrera',
  initials: 'FH',
  avatarColor: '#1d3557',
  timeAgo: '2 d',
  text: 'Nunca había agarrado una sierra en serio. Seguí los planos del banco de trabajo plegable y en el fin de semana lo tenía listo. Lo que más me gustó es que te explica cada corte con medidas exactas, no hay que interpretar nada. Muy claro.',
  likes: 187,
  hearts: 29,
  stars: 5
}, {
  name: 'Marcelo Díaz',
  initials: 'MD',
  avatarColor: '#7b2d00',
  timeAgo: '3 d',
  text: 'Compré esto sin muchas expectativas y la verdad me sorprendió. Ya vendí la primera silla plegable y recuperé lo que pagué varias veces. Los planos son muy fáciles de leer, incluso para alguien que recién empieza como yo.',
  likes: 96,
  hearts: 17,
  stars: 5
}, {
  name: 'Tomás Villanueva',
  initials: 'TV',
  avatarColor: '#4a4e69',
  timeAgo: '4 d',
  text: 'Lo que más valoro es que no necesitás experiencia previa. Cada plano tiene las medidas, los materiales y el orden de los pasos. En menos de 48 horas ya tenía mi primer proyecto terminado. Muy recomendable para el que quiere arrancar.',
  likes: 143,
  hearts: 22,
  stars: 5
}, {
  name: 'Gustavo Romero',
  initials: 'GR',
  avatarColor: '#386641',
  timeAgo: '5 d',
  text: 'Llevo 3 muebles fabricados y ya los vendí todos. El retorno fue rápido. Lo que más me ayudó fue la calculadora de rentabilidad que viene incluida. Ahora sé exactamente cuánto cobrar por cada pieza. Muy completo todo.',
  likes: 261,
  hearts: 44,
  stars: 5
}, {
  name: 'Alejandro Peralta',
  initials: 'AP',
  avatarColor: '#8b2fc9',
  timeAgo: '6 d',
  text: 'Tenía miedo de que fuera otro PDF genérico. Pero no, los planos tienen medidas exactas, lista de materiales y hasta te dicen qué herramientas necesitás. Armé una mesa ratona plegable en un día y medio. Mi señora no lo podía creer.',
  likes: 178,
  hearts: 31,
  stars: 5
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5 mb-2" data-id="element-34">
      {Array.from({
      length: count
    }).map((_, i) => <span key={i} className="text-[#f5a623] text-sm" data-id="element-35">
          ★
        </span>)}
    </div>;
}
function Avatar({
  initials,
  color
}: {
  initials: string;
  color: string;
}) {
  return <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0 select-none" style={{
    backgroundColor: color
  }} data-id="element-36">
      {initials}
    </div>;
}
function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4 flex flex-col gap-3" data-id="element-37">
      {/* Header */}
      <div className="flex items-center gap-3" data-id="element-38">
        <Avatar initials={review.initials} color={review.avatarColor} data-id="element-39" />
        <div data-id="element-40">
          <p className="font-bold text-gray-900 text-sm leading-tight" data-id="element-41">
            {review.name}
          </p>
          <p className="text-gray-400 text-xs" data-id="element-42">{review.timeAgo} · 🌐</p>
        </div>
      </div>

      {/* Stars */}
      <StarRating count={review.stars} data-id="element-43" />

      {/* Review text */}
      <p className="text-gray-700 text-sm leading-relaxed" data-id="element-44">{review.text}</p>

      {/* Reaction bar */}
      <div className="border-t border-gray-100 pt-2 flex items-center justify-between" data-id="element-45">
        {/* Reaction counts */}
        <div className="flex items-center gap-1.5" data-id="element-46">
          <div className="flex items-center" data-id="element-47">
            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#1877f2] text-white text-[10px]" data-id="element-48">
              <ThumbsUp className="w-2.5 h-2.5" data-id="element-49" />
            </span>
            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-500 text-white text-[10px] -ml-1" data-id="element-50">
              <Heart className="w-2.5 h-2.5" data-id="element-51" />
            </span>
          </div>
          <span className="text-gray-500 text-xs" data-id="element-52">
            {review.likes + review.hearts}
          </span>
        </div>

        {/* Action links */}
        <div className="flex items-center gap-3 text-xs text-gray-500 font-semibold" data-id="element-53">
          <button className="hover:text-[#1877f2] transition-colors" data-id="element-54">
            Me gusta
          </button>
          <span className="text-gray-300" data-id="element-55">·</span>
          <button className="hover:text-[#1877f2] transition-colors" data-id="element-56">
            Responder
          </button>
          <span className="text-gray-300" data-id="element-57">·</span>
          <span data-id="element-58">{review.timeAgo}</span>
        </div>
      </div>
    </div>;
}
export function FacebookReviews() {
  return <section className="py-8 md:py-16 px-4 bg-metal bg-blueprint" data-id="element-59">
      <div className="max-w-5xl mx-auto" data-id="element-60">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12" data-id="element-61">
          <h2 className="text-2xl md:text-5xl font-black text-[#E4D6B5] uppercase tracking-tight mb-4" data-id="element-62">
            Lo Que Dicen Los Carpinteros
          </h2>

          {/* Facebook-style rating summary */}
          <div className="inline-flex flex-col items-center bg-white rounded-2xl shadow-lg px-8 py-5 mt-2" data-id="element-63">
            <div className="flex items-center gap-2 mb-1" data-id="element-64">
              <span className="text-4xl font-black text-gray-900" data-id="element-65">5.0</span>
              <div className="flex gap-0.5" data-id="element-66">
                {Array.from({
                length: 5
              }).map((_, i) => <span key={i} className="text-[#f5a623] text-2xl" data-id="element-67">
                    ★
                  </span>)}
              </div>
            </div>
            <p className="text-gray-500 text-sm font-semibold" data-id="element-68">
              Basado en <span className="text-gray-800 font-bold" data-id="element-69">2.554</span>{' '}
              carpinteros
            </p>
            {/* Facebook branding hint */}
            <div className="flex items-center gap-1.5 mt-2" data-id="element-70">
              <div className="w-5 h-5 rounded-full bg-[#1877f2] flex items-center justify-center" data-id="element-71">
                <span className="text-white text-xs font-black" data-id="element-72">f</span>
              </div>
              <span className="text-gray-400 text-xs" data-id="element-73">Reseñas verificadas</span>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-74">
          {reviews.map((review, index) => <ReviewCard key={index} review={review} data-id="element-75" />)}
        </div>

        {/* CTA below reviews */}
        <div className="text-center mt-8 md:mt-12" data-id="element-76">
          <p className="text-lg md:text-2xl font-black text-[#E4D6B5] uppercase tracking-wide mb-4" data-id="element-77">
            ¡Únete a más de 2.554 carpinteros!
          </p>
          <a href="https://fabricaindustrial.com/cart/add?id=53066804855123&quantity=1&return_to=/cart" onClick={() => {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'AddToCart');
          }
        }} className="inline-flex items-center justify-center gap-2 bg-[#8B5A2B] hover:bg-[#7B4F28] text-[#E4D6B5] font-black text-base md:text-lg py-4 px-8 md:px-12 uppercase tracking-wider border-2 border-[#6F6F6F] shadow-[0_6px_0_0_#5a3a1a,0_8px_16px_0_rgba(0,0,0,0.8)] hover:shadow-[0_3px_0_0_#5a3a1a,0_4px_8px_0_rgba(0,0,0,0.9)] hover:translate-y-1 transition-all duration-200" data-id="element-78">
            QUIERO LOS +200 PLANOS ▶
          </a>
          <p className="text-xs md:text-sm text-[#C8B894] mt-3 font-semibold" data-id="element-79">
            🔒 Pago único · Acceso inmediato · Garantía 7 días
          </p>
        </div>
      </div>
      <div className="divider-industrial mt-8 md:mt-16" data-id="element-80"></div>
    </section>;
}